/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcPlaidV1ProcessorTokenState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_PLAID_V1_PROCESSOR_TOKEN_STATE_ENTITY_NAME = 'exc.plaid.v1.ProcessorToken';
export const excPlaidV1ProcessorTokenStateEntity = new schema.Entity<ExcPlaidV1ProcessorTokenState>(EXC_PLAID_V1_PROCESSOR_TOKEN_STATE_ENTITY_NAME, {}, { idAttribute: 'processorTokenId' });

